import { Component } from '@angular/core';

@Component({
  selector: 'app-header-jobs',
  templateUrl: './header-jobs.component.html',
  styleUrls: ['./header-jobs.component.css']
})
export class HeaderJobsComponent {

}
